<ng-container *ngIf="question">
    <textarea #textAreaInput type="text" ng-model="question.answer" class="form-control text-xlarge d-none"
        [placeholder]="question.placeholder" value="{{question.answer}}"
        oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
        (keyup)="internalAnswerChanged($event, question.answerId, false)"></textarea>
    <div #divTextInput class="text-xlarge">
        {{question.placeholder}}
    </div>
</ng-container>

<ng-container *ngIf="!question">
    <textarea #textAreaInput type="text" class="form-control text-xlarge d-none" ng-model="assessment.reflection"
        [placeholder]="assessment.reflectionTitle" value="{{assessment.reflection}}"
        oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
        (keyup)="internalAnswerChanged($event, assessment.id, true)"></textarea>
    <div #divTextInput class="text-xlarge">
        {{assessment.reflectionTitle}}
    </div>
</ng-container>